import { useMutation, useQuery } from '@tanstack/react-query';

import GeneratedDocumentsRepository from '@/repositories/GeneratedDocumentsRepository';
import { GenerateDocumentRequest } from '@/types/generatedDocument';

export const useDocumentTypes = () => {
  const repository = GeneratedDocumentsRepository();
  return useQuery({
    queryKey: ['documentTypes'],
    queryFn: () => repository.getTypes()
  });
};

export const useDocumentTypeOptions = (type: string | null, personId?: string) => {
  const repository = GeneratedDocumentsRepository();
  return useQuery({
    queryKey: ['documentTypeOptions', type],
    queryFn: () => repository.getTypeOptions(type!, personId),
    enabled: !!type
  });
};

export const useGeneratedDocumentsList = (personId: string, page: number = 1) => {
  const repository = GeneratedDocumentsRepository();
  return useQuery({
    queryKey: ['generatedDocuments', personId, page],
    queryFn: () => repository.listForPerson(personId, page)
  });
};

export const useGenerateDocument = () => {
  const repository = GeneratedDocumentsRepository();

  return useMutation({
    mutationFn: (data: GenerateDocumentRequest) => repository.create(data)
  });
};

export const usePreviewDocument = () => {
  const repository = GeneratedDocumentsRepository();
  return useMutation({
    mutationFn: (data: GenerateDocumentRequest) => repository.preview(data)
  });
};
